import {
  httpPostSearchSuggest,
  type SearchSearchSuggestSchema,
} from '@iconik-io/iconik-api/src/services/search';

import type { AppDispatch } from '../../store/types';
import { cancellable } from '../http/actions';

export const getSearchSuggestions =
  (body: SearchSearchSuggestSchema) => (dispatch: AppDispatch) =>
    dispatch(cancellable(httpPostSearchSuggest(body)));
